import { addDoc, collection, deleteDoc, doc, getDocs, query, setDoc } from 'firebase/firestore';
import { sendInvitationEmail } from '../../emailjs';
import { db } from './firebase';

export const getInvitations = async () => {
    const q = query(collection(db, 'invitations'))
    const docSnap = await getDocs(q);
    const docs = docSnap.docs.map(doc => {
        return { ...doc.data(), id: doc.id }
    })
    return docs
}

export const _createInvitation = async (payload) => {
    const collectionRef = collection(db, "invitations")
    const docRef = await addDoc(collectionRef, payload)
    sendInvitationEmail(payload.name, payload.email)
    return { ...payload, id: docRef.id }
}

export const _updateInvitation = async (id, data) => {
    let docRef = doc(db, 'invitations', id)
    await setDoc(docRef, { ...data }, { merge: true })
    return { data: {...data, id}, msg: 'La promoción se ha actualizado correctamente' }
}

export const _deleteInvitation = async (id) => {
    let docRef = doc(db, 'invitations', id)
    await deleteDoc(docRef)
    return { id: id }
}